'use strict';

var _ = require('lodash');
var d3 = require('d3');
var Scales = function Scales(params, data) {
  var yMin = d3.min(data, function (d) {
    return 1.1 * d.data;
  });
  yMin = yMin > 0 ? 0 : yMin;
  var yMax = d3.max(data, function (d) {
    return 1.1 * d.data;
  });
  yMax = yMax < 0 ? 0 : yMax;
  var x = d3.scale.ordinal().domain(_.map(data, 'label')).rangeRoundBands([0, params.width], 0.11, 0.05);
  var y = d3.scale.linear().domain([yMin, yMax]).rangeRound([params.height, 0]);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;